// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"DeleteSentinelModal_buttonGroup__1cVsg","infoText":"DeleteSentinelModal_infoText__1bOEx","configName":"DeleteSentinelModal_configName__Wtwl-"};